import { GeneralError, Error } from '../Utility/Constants';
import './GeneralError.css'

function CommonError() {
    return (
        <>
            <div className='generalError'>
                <div className='generalErrorTitle'>{Error}</div>
                <p className='generalErrorMessage'>{GeneralError}</p>
            </div>
        </>
    )
}

export default CommonError;

